import app from '../angular_app.es6';
import { forEach, remove } from 'lodash';

app.factory('SwipePopupService', ['$http', '$rootScope', ($http, $rootScope) => {

  let intervalId, callbacks = [], interval = 0;

  const runInterval = () => {
    if (!!intervalId) return;
    intervalId = setInterval(() => { forEach(callbacks, (item) => { item.callback() }); }, interval);
  };

  const registerCallback = (el, callback) => { callbacks.push({ id: el, callback: callback }); };
  const unregisterCallback = (el) => { remove(callbacks, (el) => el.id == el); };

  const stopInterval = () => { clearInterval(intervalId); };

  return {
    init: runInterval,
    register: registerCallback,
    unregister: unregisterCallback,
    stop: stopInterval
  }
}]);